// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { GET_POLICY_DASHBOARD, GET_POLICY_INACTIVE, DOWNLOAD_POLICY, NON_HEALTH_CLAIM } from '../../../../../common/constant'
import { get, post } from '../../../../../common/api'

export const actionGetPolicyDashboard = createAsyncThunk('dashboardStore/actionGetPolicyDashboard', async (params, thunkAPI) => {
    return await post(GET_POLICY_DASHBOARD, params, thunkAPI)
})

export const actionGetPolicyInactive = createAsyncThunk('dashboardStore/actionGetPolicyInactive', async (params, thunkAPI) => {
    return await post(GET_POLICY_INACTIVE, params, thunkAPI)
})

export const actionDownloadPolicy = createAsyncThunk('dashboardStore/actionDownloadPolicy', async (params, thunkAPI) => {
    return await get(DOWNLOAD_POLICY, params, thunkAPI)
})

export const actionNonHealthClaim = createAsyncThunk('dashboardStore/actionNonHealthClaim', async (params, thunkAPI) => {
    return await post(NON_HEALTH_CLAIM, params, thunkAPI)
})



export const dashboardSlice = createSlice({
    name: 'dashboardStore',

    initialState: {
        //get policy
        loadingGetPolicy: false,
        getPolicy: null,

        //get policy inactive
        loadingGetPolicyInactive: false,
        getPolicyInactive: null,

        //downloadpolicy
        loadingDowanloadPolicy: false,
        downloadPolicy: null,

        //non helth claim
        loadingNonHelthClaim: false,
        nonHelthClaim: null,

          //non helth claim
          loadingDummyApi: false,
          DummyApi: null,

        
    },
    reducers: {
        //reset or delete public store data
        resetGetPolicyResponse: (state) => {
            state.getPolicy = null
        },

        resetGetPolicyInactiveResponse: (state) => {
            state.getPolicyInactive = null
        },

        resetDownloadPolicyResponse: (state) => {
            state.downloadPolicy = null
        },
        resetNonHealthClaimResponse: (state) => {
            state.nonHelthClaim = null
        },

    },
    extraReducers: builder => {
        builder
            .addCase(actionGetPolicyDashboard.pending, (state) => {
                state.loadingGetPolicy = true
            })
            .addCase(actionGetPolicyDashboard.fulfilled, (state, action) => {
                state.loadingGetPolicy = true
                state.getPolicy = action.payload
            })
            .addCase(actionGetPolicyDashboard.rejected, (state) => {
                state.loadingGetPolicy = false
            })

            .addCase(actionGetPolicyInactive.pending, (state) => {
                state.loadingGetPolicyInactive = true
            })
            .addCase(actionGetPolicyInactive.fulfilled, (state, action) => {
                state.loadingGetPolicyInactive = true
                state.getPolicyInactive = action.payload
            })
            .addCase(actionGetPolicyInactive.rejected, (state) => {
                state.loadingGetPolicyInactive = false
            })

            .addCase(actionDownloadPolicy.pending, (state) => {
                state.loadingDowanloadPolicy = true
            })
            .addCase(actionDownloadPolicy.fulfilled, (state, action) => {
                state.loadingDowanloadPolicy = true
                state.downloadPolicy = action.payload
            })
            .addCase(actionDownloadPolicy.rejected, (state) => {
                state.loadingDowanloadPolicy = false
            })

            .addCase(actionNonHealthClaim.pending, (state) => {
                state.loadingNonHelthClaim = true
            })
            .addCase(actionNonHealthClaim.fulfilled, (state, action) => {
                state.loadingNonHelthClaim = true
                state.nonHelthClaim = action.payload
            })
            .addCase(actionNonHealthClaim.rejected, (state) => {
                state.loadingNonHelthClaim = false
            })   
    }
})
export const { resetGetPolicyResponse, resetGetPolicyInactiveResponse, resetDownloadPolicyResponse, resetNonHealthClaimResponse } = dashboardSlice.actions

export default dashboardSlice.reducer